import React, {useState} from "react";
import serviceLogin from "../../../services/serviceLogin";
import {Form, Input, Button, Select} from "antd";
import config from "../../../config";

const {Option} = Select

const LoginForm = () => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])

    const handleLogin = () => {

        const mockLoadState = [...loadings]
        mockLoadState[0] = true
        setLoadings(mockLoadState)
        let list = form.getFieldsValue()
        let requestObj = {
            username: list.userName,
            password: list.password
        }
        serviceLogin(requestObj)
            .then(() => {
                let mocks = [...loadings]
                mocks[0] = false
                setLoadings(mocks)
            })

    }
    const handleSelectChange = (v) => window.localStorage.setItem('tenant', v)

    return (
        <React.Fragment>
            <div className={"mb-5 text-center"}>
                <h2>Giriş Yapınız</h2>
            </div>

            <Form
                form={form}
                name={'loginForm'}
                onFinish={handleLogin}
            >
                <Form.Item
                    name={'sourceTarget'}
                    rules={[
                        {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                    ]}
                >
                    <Select
                        onChange={handleSelectChange}
                        placeholder={'Firma'}
                    >
                        <Option value={config.tenants.arma}>Armaled</Option>
                        <Option value={config.tenants.gohkan}>Gökhan Elektrik</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    name={'userName'}
                    rules={[
                        {
                            type:'email',
                            message:'Lütfen Doğru Formatta E-mail Giriniz'
                        },
                        {
                            required: true,
                            message: 'Kullanıcı Adı Boş Bırakılamaz'
                        }
                    ]}
                >
                    <Input placeholder={'Kullanıcı Adı / E-mail'}/>
                </Form.Item>
                <Form.Item
                    name={'password'}
                    rules={[
                        {
                            required: true,
                            message: 'Şifre Alanı Boş Bırakılamaz'
                        },
                    ]}
                >
                    <Input.Password placeholder={'Şifreniz'}/>
                </Form.Item>
                <Form.Item>
                    <Button
                        type={'primary'}
                        loading={loadings[0]}
                        htmlType="submit"
                    >
                        Giriş
                    </Button>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}

export default LoginForm